import React, { Dispatch, SetStateAction } from "react"
import {
  CustomReasonCode,
  InputReason,
  Maybe,
  Reason as OrderReason
} from "lib/types/generated/graphql-types"
import { Label, Wrapper } from "./Reason.styled"
import AddedReason from "./AddedReason"
import ReasonInput from "./ReasonInput"
import { useQuery } from "@apollo/client"
import ALL_REASON_CODES from "../../../../graphql/queries/settings/reasonCodes/AllReasonCodes"
import { ReasonType } from "lib/types/order"

type Props = {
  addReason: (reason: InputReason) => void
  removeReason: () => void
  loading: boolean
  orderLoading: boolean
  orderReason: Maybe<OrderReason> | undefined
  reasonType: ReasonType | undefined
  setReasonType: Dispatch<SetStateAction<ReasonType | undefined>>
}

const Reason = ({
  addReason,
  orderReason,
  removeReason,
  loading,
  orderLoading,
  reasonType,
  setReasonType
}: Props) => {
  const [reason, setReason] = React.useState<InputReason>({ cause: "", code: "" })

  const { data, loading: allCodesLoading } = useQuery(ALL_REASON_CODES)
  const customReasons = data?.Order?.customReasonCodes?.codes

  const handleAddReason = () => {
    addReason(reason)
    setReason({ cause: "", code: "" })
  }

  const getCustomCode = (code: Maybe<string> | undefined) =>
    customReasons?.find((customCode: CustomReasonCode) => customCode.code === code)

  if (orderReason)
    return (
      <Wrapper className={allCodesLoading || orderLoading ? "blur" : ""}>
        <Label>Reason</Label>
        <AddedReason
          reason={orderReason}
          removeReason={removeReason}
          loading={loading}
          getCustomCode={getCustomCode}
        />
      </Wrapper>
    )

  return (
    <Wrapper className={allCodesLoading ? "blur" : ""}>
      <Label>Reason</Label>
      <div>
        <ReasonInput
          reason={reason}
          reasonType={reasonType}
          setReasonType={setReasonType}
          setReason={setReason}
          addReason={handleAddReason}
          addReasonLoading={loading}
          customReasons={customReasons}
        />
      </div>
    </Wrapper>
  )
}

export default Reason
